window.addEventListener('DOMContentLoaded', () => {
	const swipers = document.querySelectorAll('.slider-container');
	
	swipers.forEach((swiper) => {
		const data = swiper.querySelector(`.swiper-data-handler`);
		const mySwiper = data.dataset.class;
		const sectionId = data.dataset.section;
		const swipeEffect = data.dataset.effect;
		const pagination = (data.dataset.pagination);
		const buttons = (data.dataset.buttons);
		const autoplay = (data.dataset.autoplay);
		const disableOnInteraction = (data.dataset.disable);
		const colsDesktop = Number(data.dataset.colDesktop);
		const colsMobile = Number(data.dataset.colMobile);
		const colsTablet = Number(data.dataset.colTablet);

		let myPagination = document.querySelector(`.swiper-pagination[data-target="${mySwiper}"]`)
	
		const paginationObj = {
			el: myPagination,
			clickable: true,
		};

		let mySwiperNext = document.querySelector(`.swiper-button-next[data-target="${mySwiper}"]`)
		let mySwiperPrev = document.querySelector(`.swiper-button-prev[data-target="${mySwiper}"]`)
	
		const navigationObj = {
			nextEl: mySwiperNext,
			prevEl: mySwiperPrev,
		};

		const autoplayObj = {
			delay: 3000,
			disableOnInteraction: true,
			pauseOnMouseEnter: true,
		};
		
		const swiperObj = {
            // hashNavigation: {
            //     watchState: true,
            // },
			slidesPerView: colsMobile,
			spaceBetween: 40,
            // watchSlidesProgress: true,
			keyboard: {
				enabled: true,
			},
			breakpoints: {
				768: {
					slidesPerView: colsTablet,
					spaceBetween: 40,
				},
				1440: {
					slidesPerView: colsDesktop,
					spaceBetween: 50,
				},
			},
		}
		
		if (swipeEffect && window.innerWidth < 768) {
			swiperObj.effect = swipeEffect;
		}
	
		if (pagination === 'true') {
			swiperObj.pagination = paginationObj;
		}
	
		if (buttons === 'true') {
			swiperObj.navigation = navigationObj;
		}

		if (autoplay === 'true') {
			swiperObj.autoplay = autoplayObj;
		}
	
		let swiperInstance = new Swiper(`.${mySwiper}`, swiperObj);
        // console.log(`Instancia para ${mySwiper}:`, swiperObj)

		window.addEventListener('resize', () => {
			if (window.innerWidth > 768) {
				swiperInstance.destroy(true, true);

				swiperInstance = new Swiper(`.${mySwiper}`, {
					slidesPerView: colsDesktop,
					spaceBetween: 50,
					keyboard: {
						enabled: true,
					},
					pagination: pagination ? paginationObj : false,
					navigation: buttons ? navigationObj : false,
					autoplay: autoplay ? autoplayObj : false,
				});
			} else if (swiperInstance.params.effect !== swipeEffect) {
				swiperInstance.params.effect = swipeEffect;
				swiperInstance.update();
			}
		});

		// swiperInstance.on('slideChange', function() {
		// 	swiperInstance.pagination.render();
		// 	swiperInstance.pagination.update();
		// });
	});
});
